export const EMAIL_CONTACTO = 'acostahnos@yahoo.com.ar';
export const WHATSAPP_NUMERO = '5491153837427';
export const MAIL_ASUNTO_PREFIJO = '[Consulta web]';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAILTO_MAX_CUERPO = 1800;

export function validarCorreo(correo) {
  return EMAIL_REGEX.test(String(correo || '').trim());
}

/**
 * Abre el cliente de correo del visitante (mailto) con destinatario, asunto y mensaje prellenados.
 */
export function abrirMailContacto({
  destino = EMAIL_CONTACTO,
  correoUsuario,
  asunto,
  cuerpo,
}) {
  const correo = String(correoUsuario || '').trim();
  const subject = String(asunto || '').trim();
  const mensaje = String(cuerpo || '').trim();

  if (!validarCorreo(correo)) {
    throw new Error('Ingresá un correo electrónico válido.');
  }
  if (!subject) {
    throw new Error('Ingresá un asunto.');
  }
  if (!mensaje) {
    throw new Error('Escribí un mensaje.');
  }

  const asuntoCompleto = `${MAIL_ASUNTO_PREFIJO} ${subject}`.trim();
  let cuerpoCompleto = [
    mensaje,
    '',
    '---',
    `Mi correo de contacto: ${correo}`,
    'Enviado desde el sitio web de Acosta Estructuras',
  ].join('\n');

  if (cuerpoCompleto.length > MAILTO_MAX_CUERPO) {
    cuerpoCompleto = `${cuerpoCompleto.slice(0, MAILTO_MAX_CUERPO - 48)}\n\n[... mensaje recortado]`;
  }

  const params = new URLSearchParams();
  params.set('subject', asuntoCompleto);
  params.set('body', cuerpoCompleto);

  const destinatario = encodeURIComponent(String(destino || EMAIL_CONTACTO).trim());
  window.location.href = `mailto:${destinatario}?${params.toString()}`;
}

export function abrirWhatsApp(numero, mensaje = '') {
  const texto = mensaje.trim();
  const textoCodificado = texto ? encodeURIComponent(texto) : '';
  const queryTexto = textoCodificado ? `&text=${textoCodificado}` : '';
  const esMovil = window.matchMedia('(max-width: 768px)').matches;

  if (esMovil) {
    window.location.href = `whatsapp://send?phone=${numero}${queryTexto}`;
    setTimeout(() => {
      const waMe = `https://wa.me/${numero}${textoCodificado ? `?text=${textoCodificado}` : ''}`;
      window.open(waMe, '_blank', 'noopener,noreferrer');
    }, 900);
    return;
  }

  const webUrl = `https://web.whatsapp.com/send?phone=${numero}${queryTexto}`;
  window.open(webUrl, '_blank', 'noopener,noreferrer');
}
